// Relocate an already-mounted iframe into a new parent WITHOUT reloading it.
//
// A plain appendChild/append reparents the iframe, which discards its nested browsing
// context and forces a full reload (losing app state + re-running the handshake). The
// state-preserving `Node.moveBefore()` API (Chromium 133+, Firefox 139+; not yet Safari)
// performs an atomic move that keeps the iframe's content alive. Where it isn't available,
// or the node isn't yet connected (initial insertion), we fall back to `append`, which
// reloads (current behavior).
export const relocateIframe = (parent: HTMLElement, iframe: HTMLIFrameElement): void => {
    const moveBefore = (parent as unknown as { moveBefore?: (node: Node, ref: Node | null) => void }).moveBefore;
    if (typeof moveBefore === "function" && iframe.isConnected) {
        try {
            moveBefore.call(parent, iframe, null);
            return;
        } catch {
            // moveBefore throws if the move is illegal (e.g. detached node); fall back.
        }
    }
    parent.append(iframe);
};
